import React, { useState, useEffect } from 'react'
import 'common/css/master.css'
function Slide3SubTchRoom(props) {
  const {
    lstSubTchRoom
  } = props;

  useEffect(() => {
    // console.log(lstSubTchRoom)
  }, [lstSubTchRoom])

  const colgrp = (
    <colgroup>
      <col width='20' />
      <col width='20' />
      <col width='20' />
    </colgroup>
  )

  return (
    <div className='col-sm-10 col-centered'>
      <div className="row">
        <table className='tableLayout1'>
          {colgrp}
          <thead>
            <tr>
              <th className='text-left padding-remove custom_th' style={{ fontSize: '4rem', fontWeight: 'normal' }}>
                Subject
              </th>
              <th className='text-left custom_th' style={{ fontSize: '4rem', fontWeight: 'normal' }}>
                Teacher
              </th>
              <th className='text-left custom_th' style={{ fontSize: '4rem', fontWeight: 'normal' }}>
                Room
              </th>
            </tr>
          </thead>
        </table>
        <div className='tablebodyWrapper' style={{ overflowY: 'auto', height: 'auto', width: 'calc(100% - 17px)' , pointerEvents:"none"}}>
          <table className='tableLayout'>
            {colgrp}
            <tbody>
              {lstSubTchRoom.map((obj, idx) => {
                return (
                  <tr className="custom_tr" style={{ background: idx % 2 == 0 ? '' : '#E3E3E3' }}
                    key={idx}
                    id={idx}
                  >
                    <td className='custom_td text-left' style={{ color: '#333333', fontSize: '3rem', padding:'0 1em' }}>
                      {obj.sub}
                    </td>
                    <td className='text-left' style={{ color: '#333333', fontSize: '3rem', margin: '10%'}}>
                      {obj.tch}
                    </td>
                    <td className='text-left' style={{ color: '#333333', fontSize: '3rem', margin: '10%' }}>
                      {obj.room}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}


export default Slide3SubTchRoom